export class IsUsingPasswordEmailConflictError extends Error {
  public constructor() {
    super()

    this.message = 'errors.isUsingPasswordEmailConflict'
  }
}
